var React = require('react');

function ChevronDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.41,8.59,12,13.17l4.59-4.58L18,10l-6,6L6,10Z","transform":"translate(-6 -8.59)","fill":"#767983"}));
}

ChevronDown.defaultProps = {"width":"12","height":"7.41","viewBox":"0 0 12 7.41"};

module.exports = ChevronDown;

ChevronDown.default = ChevronDown;
